import { Component, computed, input, output, type Signal } from '@angular/core';
import type { MenuItem } from 'primeng/api';
import { HierarchyPosition } from './queries';

@Component({
  selector: 'app-current-hierarchy-breadcrumbs',
  styles: [
    `
      .breadcrumb-item {
        border-radius: 0.375rem /* 6px; eq to tw rounded-md */;
      }

      .breadcrumb-item:hover {
        background: var(--gray-100);
      }

      :host ::ng-deep nav.p-breadcrumb {
        padding-bottom: 0;
        padding-top: 0;
      }
    `
  ],
  template: `
    <div>
      <p-breadcrumb class="max-w-full" [model]="data()">
        <ng-template pTemplate="item" let-item>
          <span
            class="cursor-pointer p-3"
            [ngClass]="
              item.state.isCurrent ? 'text-primary' : 'breadcrumb-item'
            "
            (mouseover)="prefetchItem()"
            (click)="switchToItem(item.id)"
          >
            {{ item.label }}
          </span>
        </ng-template>
      </p-breadcrumb>
    </div>
  `
})
export class BreadcrumbsHierarchyComponent {
  public breadcrumbs = input.required<HierarchyPosition[]>();
  public itemId = input.required<number | string>();
  public onItemSelected = output<number | string>();

  public data: Signal<MenuItem[]> = computed(() => {
    return this.breadcrumbs().map((item) => ({
      label: item.title,
      id: String(item.id),
      state: { isCurrent: item.id === this.itemId() }
    }));
  });

  public async switchToItem(id: string) {
    if (id === this.itemId().toString()) {
      // Current item, no need to switch
      return;
    }

    this.onItemSelected.emit(id);
  }

  public prefetchItem() {
    // this.currentHierarchy.prefetchQuery({ id });
    //	this.queryClient.prefetchQuery(
    //		fetchItemToSwitchOptions(id, this.dataSource),
    //	);
  }
}
